import { FavouriteItemType } from "../../../types";

import { messages } from "./FavouriteItemsTree.messages";

export const FAVOURITE_ITEMS_GROUPS = [
  {
    id: `slide`,
    name: messages.slidesGroup,
    type: FavouriteItemType.Slide,
  },
  {
    id: `map`,
    name: messages.mapsGroup,
    type: FavouriteItemType.Map,
  },
  {
    id: `bulk-export`,
    name: messages.bulkExportGroup,
    type: FavouriteItemType.BulkExport,
  },
  {
    id: `saved-bulk-export`,
    name: messages.savedBulkExportGroup,
    type: FavouriteItemType.SavedBulkExport,
  },
] as const;
